import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/callback/callback.component').then(m => m.CallbackComponent),
  },
];
